// Dati anagrafici della ditta TOP-TEC (usati in Login, Header, Footer, ecc.)
export const COMPANY_INFO = {
  brand: "TOP-TEC",
  legal: "TOP-TEC di Ebner Dorian",
  address: "Via Sant'Antonio 31 - 38030 Giovo (TN)",
  phone: "340-2830487",
  phoneTel: "+393402830487",
  email: "dorian.toptec@gmail.com",
};
